
import React, { useState, useEffect, 
    // useRef 
} from "react";

import Swal from 'sweetalert2';

import { Link } from 'react-router-dom';

import {
    TextField,
    Typography,
    Checkbox,
    FormControlLabel,
    FormControl,
    RadioGroup,
    Radio,
    // Tooltip,
    // Popover
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

import { useForm} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { font } from '../../constants/styles/styles';
import '../../styles/style.scss';

import { Footer } from '../shared/Footer';

import { termsOfService } from '../../constants/serviceTerms';
// Servicio de initToken deshabilitado import TokenService from "../../services/auth/generateToken.service";

import { actionErrorConnection } from "../../constants/component/actionErrorConnection";


import { CLIENT, EMPLOYEE } from "../../constants/models/typeUserRegister";
import authService from "../../services/auth/auth.service";
import termsAndConditionsService from "../../services/termsAndConditions.service";
 import TokenService from "../../services/auth/generateToken.service";
export const RegisterScreen = () => {

    const [selectedUserType, setSelectesUserType] = useState(CLIENT);

    const [termsStatus, setTermsStatus] = useState(false);

    const [isDisabled, setDisabled] = useState(false);

    const [urlFile, setUrlFile] = useState(false)
    const [isLoadingData, setIsLoadingData] = useState(true)
     useEffect(() => {
        TokenService.getInitToken();
        }, []);

    const CustomCheckbox = withStyles({
        root: {
          color: font.baseColor,
          '&$checked': {
            color: font.baseColor,
          },
        },
        checked: {},
      })((props) => <Checkbox color="default" {...props} />);

    const CustomRadio = withStyles({
        root: {
            color: font.baseCheckboxColor,
            '&$checked': {
                color: font.baseColor,
            },
        },
        checked: {},
    })((props) => <Radio color="default" {...props} />);

    const validationSchema = Yup.object().shape({
        an8: Yup.string().required('AN8 es requerido'),
          terms: Yup.boolean().test('','Es requerido aceptar terminos',()=> termsStatus)
      },[]);

    const {
    register,
    handleSubmit,
    formState: { errors }
    } = useForm({
    resolver: yupResolver(validationSchema)
    });

    /** 
     * Ejecuta una vez servicio para recuperar token
     * -author alSanchez - ETE
     * -version 1.0.0 - Septiembre 2021
     * 
    */
    useEffect(() => {
        termsAndConditionsService.getFileTermsAndConditions().then((response)=>{
            const byteString = window.atob(response.data.split(',')[1]);
            const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];
        
                  const ab = new ArrayBuffer(byteString.length);
                  const ia = new Uint8Array(ab);
                  for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i)
                  }
        
                  const dataBlob = new Blob([ab], { type: mimeString });
        
                  if (window?.navigator?.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}`);
                    return
                  }
            
                  const url = window.URL.createObjectURL(dataBlob);
                  setUrlFile(url)
                  setIsLoadingData(false)
                }).catch((error)=>{

              actionErrorConnection(error);
            
      })
    },[]);

    /**
     * Cambie el tipo de usuario seleccionado
     * @param {*} event - Recupera el ultimo estado del selector
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleChangeStatus = (event) => {
        setSelectesUserType(event.target.value);
    };

    /**
     * Realiza la solicitud para registrar un cliente
     * @param {*} data - información del formulario de registro
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    
    const onSubmit = async(data) => {

        const { an8 } = data;

        setDisabled(true);

        let serviceSelect;

        if(selectedUserType === CLIENT){
            serviceSelect = authService.registerClient( an8 )
        }

        if(selectedUserType === EMPLOYEE){
            serviceSelect = authService.registerEmployee( an8 )
        }

        if(serviceSelect){
            serviceSelect.then((response)=>{
                setDisabled(false);
                if(response.length > 1){
                    Swal.fire({
                      icon: 'error',
                      title: 'No se pudo completar el registro.',
                      html:`${response}`,
                      showConfirmButton: true,
                      confirmButtonText: 'Aceptar'
                    });
            
                  } else{
                    Swal.fire({
                        icon: 'success',
                        title: an8 + ' registrado exitosamente',
                        text: 'En breve recibirá un correo de confirmación para ingresar al portal',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                        })
                        history.back()
                    }
            }).catch(
                (error) => {
                    setDisabled(false);
                    console.log(error,"===============")
                    if(error.response){
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            html: 'No se pudo completar el registro. <br>' + 
                            `<span class="custom-error-text">${error.response.data.mensaje || error.response.data.state}</span>`,
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                            }
                            );
                    } else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            html: 'No se pudo completar el registro. <br>' +
                            `<span class="custom-error-text">${error.message || error}</span>`,
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                            }
                            );
                    }
                    }
            );
        }

    };

    return (
        <>
        <div className="container">
            <div className="row justify-content-center ">
                <div className="col-md-4 col-sm-9">
                <div className="login pt-3">
                <img src="/images/logo.jpg" alt="logo" className="w-75"/>
                <h1 className="text-center pt-1 pb-2 text-title">Registrar</h1>
                <div className="container h-100">
                    <div className="row h-100 justify-content-center align-items-center">
                        <form className="col-12">
                            <div className="form-group mt-2">
                                <TextField
                                required
                                id="an8"
                                name="an8"
                                label={`Número de ${selectedUserType === CLIENT ? 'cliente' : 'empleado'}`}
                                fullWidth
                                variant="outlined"
                                {...register('an8')}
                                error={!!errors.an8}
                                />
                                <Typography variant="inherit" color="error">
                                    {errors.an8?.message}
                                </Typography>
                            </div>
                            <div className="form-group mt-2">
                                <FormControl component="fieldset" className=" w-100 ">
                                    <RadioGroup className="ms-md-12 ps-md-12 w-100" aria-label="invoice" name="invoice" row value={selectedUserType} onChange={handleChangeStatus}>
                                        <FormControlLabel value={CLIENT} control={<CustomRadio />} label="Cliente" />
                                        <FormControlLabel value={EMPLOYEE} control={<CustomRadio />} label="Empleado" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="form-group mt-3">
                                <div className="row ps-0 pe-0">
                                <div className="col-12 d-flex flex-row">
                                    <FormControlLabel
                                    className="w-100"
                                      control={
                                        <CustomCheckbox
                                            id="terms"
                                            name="terms"
                                            className='ps-0 ms-0'
                                            defaultValue={ false }
                                            inputRef={register()}
                                            onChange={(e) => setTermsStatus(e.target.checked)}
                                            checked = {termsStatus}
                                        />
                                      }
                                      label={
                                        <span className="mt-2">Aceptar 
                                            <a href={urlFile} disabled={isLoadingData} rel='nooper noreferrer' target="_blank" className="alert-link">
                                                 Términos y condiciones
                                            </a>
                                        </span>
                                      }
                                    />
                                    </div>
                                    <div className="col-12 pb-3">
                                    <Typography variant="inherit" color="error">
                                        {errors.terms
                                        ? '(' + errors.terms.message + ')'
                                        : ''}
                                    </Typography>
                                    </div>
                                </div>
                            </div>
                            {/* -----INICIO - modal de terminos */}
                            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                                    <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title text-title h2" id="exampleModalLabel">Términos y condiciones</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        {termsOfService}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn custom-btn" data-bs-dismiss="modal">Cerrar</button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            {/* -----FIN - modal de terminos */}
                            <div className="form-group mt-2">
                                <button
                                    className="btn custom-btn pt-3 pb-3 w-100"
                                    onClick={handleSubmit(onSubmit)}
                                    disabled={ isDisabled }
                                >
                                    Regístrate { isDisabled && <i className="fas fa-spinner fa-spin"></i>}
                                </button>
                            </div>
                            <div className="form- group mb-1">
                            <div className="w-100 d-flex justify-content-between">
                                    <div>
                                    <Link className="btn btn-link custom-link-color" to="/auth/">
                                        Ir a Inicio de sesión
                                    </Link>
                                    </div>
                                    {/* se oculta de forma temporal */}
                                    {/* <div>
                                        <Tooltip title="Ayuda" placement="top-start" arrow>
                                            <button 
                                                className="btn custom-btn-icon-alert pe-3"
                                                ref={divRevHelp} 
                                                aria-describedby={idHelp} 
                                                variant="contained"
                                                onClick={handleClickHelp}
                                                type="button"
                                            >
                                                <i className="fas fa-question-circle"></i>
                                            </button>
                                        </Tooltip>
                                        <Popover
                                            id={idHelp}
                                            open={openHelp}
                                            anchorEl={anchorElHelp}
                                            onClose={handleCloseHelp}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                            PaperProps={{
                                                style:{
                                                    width: '400px',
                                                    boxShadow: 'none',
                                                    backgroundColor: 'transparent'
                                                }
                                            }}
                                        >
                                            <div className="pt-4 pb-2 ps-3 pe-3 alert-container">
                                                <div className="alert alert-light" role="alert">
                                                    <span className='d-block ps-3 pe-2 pb-2'>
                                                        Temas de ayuda:
                                                    </span>
                                                    <a 
                                                    href= {PDFReg} 
                                                    target='_blank'
                                                    rel='nooper noreferrer'
                                                    className="alert-link">
                                                        Manual de usuario | proceso de registro
                                                    </a>
                                                </div>
                                            </div>                  
                                        </Popover>
                                    </div> */}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
                </div>
            </div>
        </div>
            
            <Footer />
        </>
    )
}
